// extracted by mini-css-extract-plugin
export default {"menuList":"style_menuList__hjNGo"};